module.exports = __webpack_public_path__ + "img/form_background_desktop.cef90a8.webp";